"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINANCIAL_POSTING_REQUEST_EXAMPLES = exports.recordPostingEventRequestSchema = void 0;
/**
 * Request contract for the 1 Posting endpoint —
 * `PostingApplicationService.recordEvent`
 * (`backend/src/modules/financial/application/posting.application-service.ts`,
 * frozen, Stage 5C.3). No `options.notification` on this one — the
 * Application Service itself accepts no notification parameter
 * (recording a posting signal is not a patient-facing event).
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
exports.recordPostingEventRequestSchema = zod_1.z.object({
    eventType: zod_1.z.enum([
        'CHARGE_POSTED',
        'PAYMENT_RECEIVED',
        'ADVANCE_RECEIVED',
        'DEPOSIT_RECEIVED',
        'DISCOUNT_APPLIED',
        'REFUND_PROCESSED',
        'ADJUSTMENT_POSTED',
        'PACKAGE_SOLD',
    ]),
    sourceEntityType: zod_1.z.string().min(1),
    sourceEntityId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int().positive(),
    options: financial_common_request_1.financialCallOptionsSchema.optional(),
});
exports.FINANCIAL_POSTING_REQUEST_EXAMPLES = {
    recordPostingEvent: {
        eventType: 'PAYMENT_RECEIVED',
        sourceEntityType: 'FinPayment',
        sourceEntityId: '11111111-1111-1111-1111-111111111111',
        amount: 150000,
    },
};
//# sourceMappingURL=financial-posting.request.js.map